// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__2oEUa","namePhoneContainer":"style_namePhoneContainer__BTgs7"};